var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentalsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_52_6544)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8825 61.437H41.8829L30.1769 33.177C27.0729 36.2808 25.3282 40.4914 25.3282 44.8827C25.3282 49.2739 27.0729 53.4843 30.1768 56.5883C33.2806 59.6922 37.4912 61.437 41.8825 61.437ZM41.8825 28.3283C37.4912 28.3283 33.2808 30.0731 30.1769 33.177L53.3166 56.3166L53.5816 56.5819C53.5817 56.5818 53.5817 56.5818 53.5817 56.5818C56.6856 53.4803 58.4325 49.272 58.4368 44.883V44.8827C58.4368 40.4914 56.6921 36.281 53.5881 33.177C50.4844 30.0731 46.2738 28.3283 41.8825 28.3283ZM29.5022 32.5022C29.5022 32.5022 29.5023 32.5022 29.5023 32.5021C32.7869 29.2195 37.2388 27.375 41.8823 27.375C46.5237 27.3792 50.9737 29.2262 54.2564 32.5088C57.5392 35.7913 59.3858 40.2412 59.39 44.8828C59.3899 49.5262 57.5454 53.978 54.2628 57.2627C54.2628 57.2627 54.2628 57.2627 54.2628 57.2628L29.5022 32.5022Z",
    stroke: "white",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6946 44.0311H44.2793C44.0217 43.3094 43.4554 42.7431 42.7337 42.4855V34.6638C42.7337 34.1933 42.3527 33.8123 41.8822 33.8123C41.4117 33.8123 41.0306 34.1933 41.0306 34.6638V42.4855C40.2046 42.7751 39.5852 43.4691 39.3914 44.3228C39.1977 45.1786 39.4553 46.0727 40.0748 46.6901C40.6921 47.3096 41.5863 47.5672 42.4421 47.3735C43.2958 47.1797 43.9898 46.5602 44.2793 45.7342H48.6946C49.1651 45.7342 49.5462 45.3532 49.5462 44.8827C49.5462 44.4122 49.1651 44.0311 48.6946 44.0311ZM41.8822 45.7342C41.5373 45.7342 41.2265 45.5277 41.0945 45.2083C40.9646 44.8911 41.037 44.525 41.2797 44.2802C41.5245 44.0375 41.8907 43.9651 42.2079 44.095C42.5272 44.2269 42.7337 44.5378 42.7337 44.8826C42.7337 45.3531 42.3527 45.7342 41.8822 45.7342Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_6544",
    x1: 26.5,
    y1: 8.5,
    x2: 56,
    y2: 78.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033F49",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentalsIcon);
export default __webpack_public_path__ + "static/media/rentals-icon.84b34de386db4d9e48565146dadb3f23.svg";
export { ForwardRef as ReactComponent };